(() => {
  if (customElements.get('index-banner-slide')) return;

  class IndexBannerSlide extends HTMLElement {
    connectedCallback() {
      this.initialize = this.initialize.bind(this);
      this.selectBlock = this.selectBlock.bind(this);
      this.addEventListener('shopify:block:select', this.selectBlock);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
      } else {
        this.initialize();
      }
    }

    initialize() {
      const root = this.querySelector('.index-banner__slider');
      const slides = this.querySelectorAll('.index-banner__slide');
      if (!this.isConnected || this.slider || !root || slides.length < 2 || !window.Splide) return;

      this.slider = new window.Splide(root, {
        type: 'fade',
        rewind: true,
        perPage: 1,
        arrows: false,
        pagination: true,
        autoplay: this.dataset.autoplay === 'true' && !window.Shopify?.designMode,
        speed: Number(this.dataset.speed) || 600,
        interval: Number(this.dataset.interval) || 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        resetProgress: true,
        keyboard: false,
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' },
      });
      this.slider.mount();
    }

    selectBlock(event) {
      if (!this.slider) return;
      const slides = Array.from(this.querySelectorAll('.index-banner__slide'));
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index < 0) return;
      this.slider.Components.Autoplay.pause();
      this.slider.go(index);
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.initialize);
      this.removeEventListener('shopify:block:select', this.selectBlock);
      this.slider?.destroy(true);
      this.slider = null;
    }
  }

  customElements.define('index-banner-slide', IndexBannerSlide);
})();
